import { defaultTo } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { AuthContext } from '../../common/Auth';
import { productApi } from '../../redux/api/productApi';
import { useAppSelector } from '../../redux/hooks';
import useWishlistLabel from '../../redux/selectors/wishlistLabelSelectors';
import { pathNames, pathRoutes } from '../../shared/infrastructure/breadcrumb';
import MuiBreadcrumb from './MuiBreadcrumb';

const MainBreadCrumb = ({ isStatic = false, staticPageName = '' }) => {
  const [mappedData, setMappedData] = useState([]);
  const [breadCrumbData, setBreadCrumbData] = useState([]);
  const [idToShow, setIdToShow] = useState('');
  let locationState = useLocation();
  let productPage = false;
  const { settingData, categoriesList } = useContext(AuthContext);

  const { id } = useParams();
  const params = useParams();
  const match = { params: params };
  const { pageName } = match.params;

  const managementProd = useAppSelector(
    (state) => productApi.endpoints.getManagementProduct.select({ id })(state)?.data,
  );
  const { wishlistRelabel } = useWishlistLabel();
  const currentProduct = useSelector((state) => defaultTo(state.productData.currentProduct, {}));

  useEffect(() => {
    if (!breadCrumbData?.length) {
      return;
    }
    if (currentProduct) {
      const index = breadCrumbData.findIndex((x) => x.name === currentProduct.id);
      if (index > 0) {
        breadCrumbData[index].name = currentProduct.productName;
      }
    }
    if (managementProd) {
      const mIndex = breadCrumbData.findIndex((x) => x.name === managementProd?._id);
      if (mIndex > 0) {
        breadCrumbData[mIndex].name = managementProd?.productName;
        breadCrumbData[mIndex].path = '/product-management';
      }
    }
    setMappedData(breadCrumbData);
  }, [currentProduct, breadCrumbData, managementProd]);

  useEffect(() => {
    if (settingData && settingData?.length) {
      settingData.forEach((val) => {
        if (val.settingsName === 'General') {
          setIdToShow(val?.values?.itemNumberToShowAtwebstore);
        }
      });
    }

    if (categoriesList?.length === 0) {
      return;
    }
    const paths = locationState.pathname.split('/');
    const itemsAdded = [
      {
        name: pathNames.Home,
        path: '/',
      },
    ];

    if (isStatic) {
      itemsAdded.push({
        name: staticPageName,
        path: '', // static page is always the last element so no navigation in breadcrumb needed
      });
    } else {
      paths.forEach((pathItem) => {
        if (pathItem !== '') {
          // validate edge cases
          if (pathItem === 'products' || pathItem === 'product') {
            itemsAdded.push({
              name: pathNames.products,
              path: pathRoutes.products,
            });
            if (pathItem === 'product') {
              if (localStorage.getItem('catTree')) {
                const catTree = JSON.parse(localStorage.getItem('catTree'));
                catTree.forEach((x) => {
                  itemsAdded.push({
                    name: x,
                    path: x.replace(/ /g, '-'),
                  });
                });
              }
              if (currentProduct && idToShow) {
                let name =
                  idToShow === 'productId'
                    ? currentProduct.productId || ''
                    : currentProduct.inhouseId || '';

                name += ' ' + currentProduct.productName;

                itemsAdded.push({
                  name: name || pathItem,
                  path: pathItem,
                });
                productPage = true;
              }
            }
          } else if (pathItem === 'newcheckout') {
            itemsAdded.push({
              name: 'Checkout',
              path: pathItem,
            });
          } else if (pathItem === 'wishlist') {
            itemsAdded.push({
              name: wishlistRelabel,
              path: pathItem,
            });
          } else {
            const catPathName = categoriesList.find(
              (x) =>
                x.categoryName.replace(/ /g, '-').toLowerCase() ===
                pathItem.replace(/ /g, '-').toLowerCase(),
            );
            const path = catPathName ? catPathName.categoryName : pathItem;
            if (!productPage)
              itemsAdded.push({
                name: path,
                path: pathItem,
              });
          }
        }
      });
    }

    let temportalPath = itemsAdded[0].path;
    for (let i = 1; i < itemsAdded.length; i++) {
      temportalPath += itemsAdded[i].path + '/';
      itemsAdded[i].path = temportalPath;
    }

    setBreadCrumbData(itemsAdded);
  }, [locationState, categoriesList, settingData, idToShow, currentProduct]);

  return <MuiBreadcrumb breadCrumbData={mappedData} />;
};

export default MainBreadCrumb;
